import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getClientReviewContext } from "../api/clientReviews";
import { getSurveyContext } from "../api/clientSurveys";

export default function PublicFeedbackRedirect() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [error, setError] = useState("");

  useEffect(() => {
    let mounted = true;
    const encodedToken = encodeURIComponent(token || "");

    if (!token) {
      navigate("/portal/review", { replace: true });
      return () => {
        mounted = false;
      };
    }

    const resolveToken = async () => {
      setError("");
      try {
        await getClientReviewContext(token);
        if (mounted) {
          navigate(`/portal/review?token=${encodedToken}`, { replace: true });
        }
        return;
      } catch {
        // Some copied preview links have used /f even though survey previews live under /s.
      }

      try {
        await getSurveyContext(token);
        if (mounted) {
          navigate(`/s/${encodedToken}`, { replace: true });
        }
      } catch {
        if (mounted) {
          setError(
            "This feedback link could not be loaded. Survey preview links expire after 1 hour. In Marketing > Surveys, use Preview Survey Link to open a fresh preview."
          );
        }
      }
    };

    resolveToken();

    return () => {
      mounted = false;
    };
  }, [navigate, token]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center px-4">
      <div className="w-full max-w-xl rounded-3xl border border-slate-200 bg-white shadow-2xl overflow-hidden">
        <div className="bg-rose-500 px-6 py-4">
          <h1 className="text-xl md:text-2xl font-semibold text-white">
            Client Feedback
          </h1>
          <p className="text-sm text-rose-100">
            Checking this feedback link.
          </p>
        </div>
        <div className="px-6 py-6">
          {error ? (
            <div className="rounded-2xl border border-rose-200 bg-rose-50 px-4 py-3 text-rose-700 text-sm md:text-base">
              {error}
            </div>
          ) : (
            <div className="rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3 text-slate-600 text-sm md:text-base">
              Loading feedback...
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
